<template>
  <button
    :type="type"
    class="icon-button"
    :class="`${colorClass} ${variantClass} ${iconColorClass}`"
    :style="{ width: `${width}px`, height: `${height}px` }"
    :disabled="disabled"
    v-on="$listeners">
    <span
      class="material-icons"
      :style="{ fontSize: `${iconSize}px`}">
      {{ icon }}
    </span>
  </button>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'l-blue'
    },
    iconColor: {
      type: String,
      default: 'white'
    },
    variant: {
      type: String, // 'contained' | 'flat'
      default: 'contained'
    },
    width: {
      type: [String, Number],
      default: null
    },
    height: {
      type: [String, Number],
      default: null
    },
    iconSize: {
      type: [String, Number],
      default: null
    },
    type: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    colorClass() {
      return `btn-${this.color} bg-${this.color}`
    },
    variantClass() {
      if (this.variant === 'flat') {
        return '--flat'
      }
      return ''
    },
    iconColorClass() {
      return `text--${this.iconColor}`
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-button {
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 2px 6px $grey05;
  border-radius: 50%;
  border: none;
  width: 32px;
  height: 32px;

  &.--flat {
    box-shadow: none;
  }

  &:disabled {
    background-color: $grey03;
  }
}
</style>